export default "__VITE_ASSET__XdjUW7ni__"